/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../components/StepperTabs/StepTab";
import React from "react";
import AssignedTab from "./AssignedTab";
import RequestTab from "./RequestTab";
import HistoryTab from "./HistoryTab";
import {TABS_TRANSPORT_REQUEST} from "../Model/Model";

const TransportRequestSupplier = ({
                                      supplierId,
                                      setShowDeleteModal,
                                      setShowAcceptRequest,
                                      setShowDeclineRequest,
                                      setShowAssignEmployeesAndVehicles,
                                      setShowPreDepartureComment,
                                      setShowDepartureComment,
                                      setShowArrivalComment,
                                      setShowDetails,
                                      setShowInTransitIssueComment,
                                      setShowIssueComment,
                                      setRow,
                                      steps,
                                      activeStep,
                                      setActiveStep,
                                      handleStepChange,
                                      modified,
                                      setModified
                                  }) => {

    return (
        <>
            <StepperTabs
                id={null}
                onlyTab={true}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_TRANSPORT_REQUEST.ASSIGNED_REQUEST.INDEX} activeStep={activeStep} normalHeight={true} >
                    { activeStep === TABS_TRANSPORT_REQUEST.ASSIGNED_REQUEST.INDEX &&
                        <AssignedTab
                            supplierId={supplierId}
                            setShowDeleteModal={setShowDeleteModal}
                            setShowAcceptRequest={setShowAcceptRequest}
                            setShowDeclineRequest={setShowDeclineRequest}
                            setShowAssignEmployeesAndVehicles={setShowAssignEmployeesAndVehicles}
                            setShowPreDepartureComment={setShowPreDepartureComment}
                            setShowDepartureComment={setShowDepartureComment}
                            setShowArrivalComment={setShowArrivalComment}
                            setShowInTransitIssueComment={setShowInTransitIssueComment}
                            setShowIssueComment={setShowIssueComment}
                            setRow={setRow}
                            modified={modified}
                            setModified={setModified}
                        />
                    }
                </StepTab>

                <StepTab index={TABS_TRANSPORT_REQUEST.OPEN_REQUEST.INDEX} activeStep={activeStep} normalHeight={true} >
                    {activeStep === TABS_TRANSPORT_REQUEST.OPEN_REQUEST.INDEX &&
                        <RequestTab
                            supplierId={supplierId}
                            setShowDeleteModal={setShowDeleteModal}
                            setShowAcceptRequest={setShowAcceptRequest}
                            setShowDepartureComment={setShowDepartureComment}
                            setRow={setRow}
                            modified={modified}
                            setModified={setModified}
                        />
                    }
                </StepTab>

                <StepTab index={TABS_TRANSPORT_REQUEST.HISTORY.INDEX} activeStep={activeStep} normalHeight={true} >
                    {activeStep === TABS_TRANSPORT_REQUEST.HISTORY.INDEX &&
                        <HistoryTab
                            checkbox={false}
                            supplierId={supplierId}
                            setShowDeleteModal={setShowDeleteModal}
                            setShowDetails={setShowDetails}
                            setRow={setRow}
                            modified={modified}
                            setModified={setModified}
                        />
                    }
                </StepTab>


            </StepperTabs>
        </>
    )

}

export default TransportRequestSupplier;
